import { ArrowLeftOutlined } from '@ant-design/icons';
import { Space, Typography } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Routes } from '../../../app/routes';
import IconWrapper from '../icon-wrapper/icon-wrapper';
import styles from './go-back.module.css';
import { useGoBack } from '../../hooks/use-go-back';

interface Props {
  children: string;
  fallbackRoute: Routes;
}

const GoBack = ({ children, fallbackRoute }: Props): JSX.Element => {
  const navigate = useNavigate();
  const goBackUrl = useGoBack(fallbackRoute);

  const goBack = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    navigate(goBackUrl, { replace: true });
  };

  return (
    <Space size={14}>
      <a href="#" onClick={goBack}>
        <IconWrapper>
          <ArrowLeftOutlined className={styles.icon} />
        </IconWrapper>
      </a>
      <Typography className={styles.title}>{children}</Typography>
    </Space>
  );
};

export default GoBack;
